import { z } from "zod";
import { ShortText, UrlText } from "./common.js";
/**
 * Link card — Hoshin canvas Yjs-native (PB-234). A quick link to a doc,
 * dashboard, or runbook: a `label` and an `href`. `href` uses `UrlText` (2048),
 * NOT `MediumText` — signed dashboard/runbook URLs routinely exceed 500 chars,
 * and a `MediumText` cap would silently drop them via `paramsFromY`. The http(s)
 * scheme guard (`isSafeHttpUrl`, packages/ui) rejects `javascript:`/`data:`/
 * relative at render time and renders an inert state rather than a live anchor.
 */
export const LinkCardParamsSchema = z
    .object({
    label: ShortText,
    href: UrlText,
})
    .strict();
export const defaultLinkCardParams = {
    label: "",
    href: "",
};
//# sourceMappingURL=linkCard.js.map